import * as React from "react"
import * as _ from "lodash"
import {ITypeFormQuestionnaire} from "../models/ITypeFormQuestionnaire";

/**
 * Created by aditya on 16/05/18.
 */

export interface TypeFormContainerProps {
    typeFormData: ITypeFormQuestionnaire[];
    questionIdList: string[];
}


export interface TypeFormContainerState {
    isExpanded: boolean;
}

class TypeFormContainer extends React.Component<TypeFormContainerProps, TypeFormContainerState> {

    constructor(props: TypeFormContainerProps) {
        super(props);
        this.state = {
            isExpanded: false
        }
    }

    filterQuestionnaire = () => {
        let filteredList: ITypeFormQuestionnaire[] = [];
        _.map(this.props.typeFormData, (questionObject: ITypeFormQuestionnaire) => {
            if (this.props.questionIdList.indexOf(questionObject.meta.typeFormQuestionId) !== -1) {
                filteredList.push(questionObject);
            }
        })
        return filteredList;
    }

    generateAnswerString = (answerList: any) => {
        let answer = "";
        if (!_.isEmpty(answerList)) {
            answer = answerList.map((item: any) => item.answer).join(",");
        }
        return answer.replace("false", "No").replace("true", "Yes");
    }

    toggleTypeForm = () => {
        this.setState({
            isExpanded: !this.state.isExpanded
        })
    }

    render() {
        let myInstance = this;
        let filteredQuestions = this.filterQuestionnaire();
        return (
            <div className="patient-typeForm-cont">
                {
                    !this.state.isExpanded &&
                    <a className={"toggle-typeform-anchor"} onClick={this.toggleTypeForm}>
                        <span className={"glyphicon glyphicon-play"} />
                        Patient Inputs
                    </a>
                }
                {
                    this.state.isExpanded &&
                        <div className={"patient-typeform-questionnaire"}>
                            <div className={"typeform-header"}>Filled by Patient</div>
                            {
                                _.map(filteredQuestions, (questionObject: ITypeFormQuestionnaire) => {
                                    return <div>
                                        <span className={"question-string brandon-bold"}>{questionObject.question}</span>
                                        <span className={"answer-string"}>{this.generateAnswerString(questionObject.answerResponses)}</span>
                                    </div>
                                })
                            }
                        </div>
                }
            </div>
        );
    }
}

export default TypeFormContainer;